import PropTypes from 'prop-types';
import React, { Suspense, useEffect, useEffectEvent } from 'react';
import { CHAT_VIEW_STATES, useCurrentChat } from '@guuru/chat-web';
import { BOTS } from '@guuru/expert-common';
import { Loading } from '@guuru/react-loading';
import BottomBar from '../BottomBar';
import ChatRequestFeedback from './ChatRequestFeedback';
import ChatThanks from './ChatThanks';

const ChatThankYouSection = function ({
  isUser,
  expert = {},
  doBefore = () => {},
}) {
  const { feedbackSubmitted, viewState, chatId } = useCurrentChat();
  const isExpert = ![BOTS.bot.externalId].includes(expert?.id);
  const isEnabled =
    isUser &&
    chatId &&
    viewState === CHAT_VIEW_STATES.finished &&
    expert?.id !== undefined;

  const handleBefore = useEffectEvent(() => doBefore());

  useEffect(() => {
    if (isEnabled) handleBefore();
  }, [isEnabled]);

  if (!isEnabled) {
    return null;
  }

  return (
    <BottomBar isUser={isUser}>
      <Suspense fallback={<Loading />}>
        {!feedbackSubmitted && isExpert ? (
          <ChatRequestFeedback chatId={chatId} />
        ) : (
          <ChatThanks chatId={chatId} />
        )}
      </Suspense>
    </BottomBar>
  );
};

ChatThankYouSection.propTypes = {
  isUser: PropTypes.bool.isRequired,
  expert: PropTypes.shape({
    id: PropTypes.string,
  }),
  doBefore: PropTypes.func,
};

export default ChatThankYouSection;
